<template>
  <div>
    <apexchart type="pie" class="p-12 text-2xl m-12" height="640" id="chart" :options="chartOptions" v-if="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script> 
/*
firstFundReport
*/
import http from "../services/http";
import VueApexCharts from 'vue-apexcharts';  
export default {
  components:{ 
    apexchart: VueApexCharts,
  },
  data() {
    return {
      series: [], // lead_count values will be stored here
      chartOptions: null, // chartOptions başlangıçta null
    };
  },
  mounted() {

    this.fetchData();
    setInterval(() => {
      this.fetchData();
    }, 600000);
  },
  methods: {
    fetchData() {

      http.firstFundReport()
        .then(response => {
          const data = response.data;

          const labels = data.map(item => item.agent_name + '  ( '+item.lead_count+' )');
          const series = data.map(item => item.lead_count);

          this.series = series;
          this.chartOptions = { 
            labels: labels,
          
            legend: {
              position: 'left',
              fontSize:'22px'
            },
            dataLabels: {
              enabled: true,
              formatter: function(val, opts) {
                return opts.w.config.labels[opts.seriesIndex];
              },
              style: {
                fontSize: '20px', 
              }
            },

          };
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    }
  }
};
</script>
